import { Box, Typography } from "@mui/material";
import { FC } from "react";

interface BoxCardProps {
    text: string;
}

export const CategorieBox: FC<BoxCardProps> = ({ text }) => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            bgcolor="secondary.main"
            borderRadius="4px"
            p={0.5}
            width="50px"
            height="12px"
        >
            <Typography color="white" variant="subtitle2" fontSize={10} fontWeight={600}>
                {text}
            </Typography>
        </Box>
    );
};
